import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import Heading from "../../elements/heading";
import Input from "../../elements/input";
import PrimaryButton from "../../elements/primary-button";
import SimpleLink from "../../elements/simple-link";
import BodyText from "../../elements/body-text";
import "./style.scss";
import { isBizNull } from "../../utils";
import { isValidEmail } from "../../utils/validations";
import ResetPassword from "../../components/ResetPassword";
import api from "../../utils/api";

const LoginForm = ({
  formTitleType,
  formTitleBody,
  description,
  emailLabel,
  emailWarningMessage,
  emailMissingMessage,
  passwordLabel,
  passwordWarningMessage,
  passwordMissingMessage,
  loginFailedMessage,
  loginWrongEmailOrPasswordMessage,
  loginNetworkErrorMessage,
  loginAccountLockMessage,
  temporaryLockMessage,
  loginFailed,
  loginNetworkError,
  loginWrongEmailOrPassword,
  loginAccountLock,
  temporaryLock,
  ctaName,
  colorScheme,
  iconName,
  resetPasswordButtonText,
  submitLogin,
  resetPasswordModal,
  lang
}) => {
  const [formDataEmail, setEmail] = useState();
  const [formDataPassword, setPassword] = useState();
  const [emailError, setEmailError] = useState(null);
  const [passwordError, setPasswordError] = useState(null);
  const [openResetPassword, setOpenResetPassword] = useState(null);
  const [autoFilled, setAutoFilled] = useState(false);

  useEffect(() => {
    if (resetPasswordModal && resetPasswordModal[0] && window.location.search.includes(`modal=${resetPasswordModal[0].fields.urlParam.value}`)) {
      setOpenResetPassword(true);
    }
  }, []);

  useEffect(() => {
    if (formDataEmail && formDataPassword && autoFilled) {
      if (validateForm()) {
        const formData = { email: formDataEmail, password: formDataPassword };
        submitLogin(null, formData);
      }
    }
  }, [formDataEmail, formDataPassword, autoFilled]);

  const onEmailFocus = evt => {
    setEmailError(null);
  };
  const onEmailBlur = (evt, valid) => {
    setEmail(evt.target.value);
    if (valid === false) {
      setEmailError(emailWarningMessage.value);
    } else {
      setEmailError(null);
    }
  };
  const onPasswordFocus = evt => {
    setPasswordError(null);
  };
  const onPasswordBlur = evt => {
    setPassword(evt.target.value);
  };
  const onSubmit = evt => {
    const formData = { email: formDataEmail, password: formDataPassword };
    const inputs = document.getElementsByTagName('input');
    if (validateForm()) {
      submitLogin(evt, formData);
    } else if (inputs.email.value && inputs.password.value) {
      setEmail(inputs.email.value)
      setPassword(inputs.password.value)
      setAutoFilled(true)
      if (validateForm()) {
        submitLogin(evt, formData);
      }
    }
  };

  const showResetPassword = evt => {
    setOpenResetPassword(true);

    let newUrl = window.location.href;
    if (window.location.search) {
      newUrl = `${newUrl}&modal=${resetPasswordModal[0].fields.urlParam.value}`;
    } else {
      newUrl = `${newUrl}?modal=${resetPasswordModal[0].fields.urlParam.value}`;
    }
    window.history.replaceState(null, null, newUrl);
  };

  const hideResetPassword = () => {
    setOpenResetPassword(false);
    let newUrl = "";
    if (window.location.search.includes(`?modal=${resetPasswordModal[0].fields.urlParam.value}`)) {
      newUrl = window.location.href.replace(`?modal=${resetPasswordModal[0].fields.urlParam.value}`, "");
    } else if (window.location.search.includes(`&modal=${resetPasswordModal[0].fields.urlParam.value}`)) {
      newUrl = window.location.href.replace(`&modal=${resetPasswordModal[0].fields.urlParam.value}`, "");
    } else {
      newUrl = window.location.href.replace(`modal=${resetPasswordModal[0].fields.urlParam.value}`, "");
    }

    window.history.replaceState(null, null, newUrl);
  };

  const resetPasswordProps = {
    open: openResetPassword,
    onCloseClicked: hideResetPassword,
    isInConfirmationStep: false,
    sendResetPasswordLink: async (evt, data) => {
      return await api.password.resetlink(null, {
        email: data.email
      });
    },
    ...resetPasswordModal[0]
  };

  const validateForm = () => {
    let result = true;
    if (isBizNull(formDataEmail)) {
      result = false;
      setEmailError(emailMissingMessage.value);
    } else if (!isValidEmail(formDataEmail)) {
      result = false;
      setEmailError(emailWarningMessage.value);
    } else {
      setEmailError(null);
    }
    if (isBizNull(formDataPassword)) {
      result = false;
      setPasswordError(passwordMissingMessage.value);
    } else {
      setPasswordError(null);
    }
    return result;
  };
  return (
    <>
      <form className="login-form" autoComplete="on">
        {formTitleBody && <Heading type={formTitleType} className="title show-on-scroll" html={formTitleBody} typographyClass={"type-h3"} />}
        {description && <BodyText html={description.value} className="description" />}
        {emailLabel && (
          <Input
            {...{
              autocomplete: "email",
              name: "email",
              label: emailLabel.value,
              warningMessage: emailError,
              type: "email",
              showError: emailError !== null,
              onFocus: evt => onEmailFocus(evt),
              onBlur: (evt, valid) => onEmailBlur(evt, valid)
            }}
          />
        )}

        {passwordLabel && (
          <Input
            {...{
              autocomplete: "current-password",
              name: "password",
              label: passwordLabel.value,
              warningMessage: passwordError,
              showError: passwordError !== null,
              skipValidation: true,
              onFocus: evt => onPasswordFocus(evt),
              type: "password",
              onBlur: evt => onPasswordBlur(evt)
            }}
          />
        )}

        {loginFailed && loginFailedMessage && <span className="login-failed-message">{loginFailedMessage.value}</span>}
        {loginAccountLock && loginAccountLockMessage && <span className="login-failed-message">{loginAccountLockMessage.value}</span>}
        {temporaryLock && temporaryLockMessage && <span className="login-failed-message">{temporaryLockMessage.value}</span>}
        {loginNetworkError && loginNetworkErrorMessage && <span className="login-failed-message">{loginNetworkErrorMessage.value}</span>}
        {loginWrongEmailOrPassword && loginWrongEmailOrPasswordMessage && <span className="login-failed-message">{loginWrongEmailOrPasswordMessage.value}</span>}

        <div className="button-container">
          {ctaName && (
            <PrimaryButton
              {...{
                colorScheme: colorScheme,
                iconName: iconName,
                link: {
                  value: {
                    text: ctaName.value
                  }
                },
                callback: evt => onSubmit(evt)
              }}
            />
          )}

          {resetPasswordButtonText && <SimpleLink text={resetPasswordButtonText.value} className="forgot-password" callback={showResetPassword} />}
        </div>
      </form>
      {resetPasswordModal[0]?.fields && <ResetPassword {...resetPasswordProps} />}
    </>
  );
};

LoginForm.propTypes = {
  formTitleType: PropTypes.object,
  formTitleBody: PropTypes.object,
  emailLabel: PropTypes.shape({ value: PropTypes.string }),
  emailWarningMessage: PropTypes.shape({ value: PropTypes.string }),
  passwordLabel: PropTypes.shape({ value: PropTypes.string }),
  passwordWarningMessage: PropTypes.shape({ value: PropTypes.string }),
  loginFailedMessage: PropTypes.shape({ value: PropTypes.string }),
  loginFailed: PropTypes.bool,
  ctaName: PropTypes.object,
  colorScheme: PropTypes.object,
  iconName: PropTypes.object,
  resetPassword: PropTypes.object,
  submitLogin: PropTypes.func
};

LoginForm.defaultProps = {
  submitLogin: () => { }
};

export default LoginForm;
